import { render, staticRenderFns } from "./contract-history.vue?vue&type=template&id=f0c06822&scoped=true&"
import script from "./contract-history.vue?vue&type=script&lang=js&"
export * from "./contract-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c06822",
  null
  
)

export default component.exports